var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('MultiplePickerInput',_vm._b({attrs:{"value":_vm.value,"items":_vm.items},on:{"input":_vm.onInput}},'MultiplePickerInput',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }